import { BitmapImage2D } from '../image/BitmapImage2D';
var DefaultGraphicsFactory = /** @class */ (function () {
    function DefaultGraphicsFactory() {
    }
    DefaultGraphicsFactory.prototype.createImage2D = function (width, height, transparent, fillColor, powerOfTwo) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = null; }
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        return new BitmapImage2D(width, height, transparent, fillColor, powerOfTwo);
    };
    return DefaultGraphicsFactory;
}());
export { DefaultGraphicsFactory };
